<template>
  <!-- <div class="content pd-0 ">
      <slot name="content-header"></slot>
      <homevet v-if="activeGroup==9233" />
      <homeasset v-else-if="activeGroup==9237" />      
  </div>-->
  <div class="content-fixed">
    <div class="container pd-x-0 pd-lg-x-30 pd-lg-y-40 text-center">
      <h4>Дүрээ сонгоно уу?</h4>
      <div class="row">
        <div v-for="(grp, i) in myDefaultPages" :key="i" class="col-12">
          <label>{{ grp.title }}</label>
          <div class="row">
            <div
              v-for="(role, i) in grp.roles"
              :key="i"
              class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4"
            >
              <div class="card">
                <template v-if="role.version == 2">
                  <a
                    target="_blank"
                    :href="`${v2BaseUrl}/#/dl/${getToken()}/${
                      role.v2.type
                    }/${encodeURIComponent(role.v2.link)}/${role.v2.name}`"
                    role="button"
                    class="card-body pd-y-50"
                  >
                    <p class="card-text tx-18">
                      <feather :type="role.icon"></feather>
                      <span class="mg-l-10"
                        >{{ role.title }}
                        <feather
                          type="external-link"
                          style="top: -10px; position: relative"
                        ></feather
                      ></span>
                    </p>
                  </a>
                </template>
                <template v-else-if="role.version == 8501">
                  <a
                    @click="showAttestModal()"
                    role="button"
                    class="card-body pd-y-50"
                  >
                    <p class="card-text tx-18">
                      <feather :type="role.icon"></feather>
                      <span class="mg-l-10">{{ role.title }} </span>
                    </p>
                  </a>
                </template>
                <template v-else>
                  <router-link
                    :to="role.rawLink"
                    role="button"
                    class="card-body pd-y-50"
                  >
                    <p class="card-text tx-18">
                      <feather :type="role.icon"></feather>
                      <span class="mg-l-10">{{ role.title }}</span>
                    </p>
                  </router-link>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      size="xl"
      hide-footer
      :title="attestModal.title"
      v-model="attestModal.show"
    >
      <div>
        <!-- {{ attestModal.types }} -->
        <div class="row text-center">
          <div
            v-for="type in attestModal.types"
            :key="`rta-${type.id}`"
            class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4"
          >
            <div class="card">
              <router-link
                :to="`/attestat/list/533/0/0/${type.id}`"
                role="button"
                class="card-body pd-y-50"
              >
                <p class="card-text tx-18">
                  <feather type="award"></feather>
                  <span class="mg-l-10">{{ type.s1 }}</span>
                </p>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
// import { hasOneOf } from "@/libs/tools";
// import { request } from "@/api/all";

// import AsyncLoadError from "@/components/base/asyncLoadingError";
// import AsyncLoading from "@/components/base/asyncLoading";

import config from "@/config";
const { mobAppActiveGroup } = config;
const { roleDefaultPages } = config;
import { hasOneOf } from "@/libs/tools";
import { getToken } from "@/libs/util";
import { request } from "@/api/all";

export default {
  components: {
    // homevet: () => ({
    //   component: import("@/views/home/apps/vetmed"),
    //   loading: AsyncLoading,
    //   error: AsyncLoadError,
    //   delay: 100,
    //   timeout: 5000
    // }),
    // homeasset: () => ({
    //   component: import("@/views/home/apps/assetmanagement"),
    //   loading: AsyncLoading,
    //   error: AsyncLoadError,
    //   delay: 100,
    //   timeout: 5000
    // }),
    // lmsHome: () => ({
    //   component: import("@/views/modules/lms/index.vue"),
    //   loading: AsyncLoading,
    //   error: AsyncLoadError,
    //   delay: 100,
    //   timeout: 5000
    // }),
  },
  data: () => ({
    activeGroup: mobAppActiveGroup,
    learnMode: true,
    moduleKey: 0,
    myDefaultPages: [],
    v2BaseUrl: "",
    attestModal: {
      title: "Та тохирох дүрийг сонгоно уу",
      show: false,
      types: [],
    },
  }),
  mounted() {
    let self = this;

    if(this.$store.state.app.activeGroup.directPage!=undefined && this.$store.state.app.activeGroup.directPage.has==true) {
      this.$router.push({name: this.$store.state.app.activeGroup.directPage.route});
    }else {
      //let myAccess=;
      this.v2BaseUrl = this.$store.state.app.activeGroup.v2BaseUrl;
      this.myDefaultPages = roleDefaultPages.filter(
        (x) => x.roles.filter((r) => self.hasPermission(r.role)).length > 0
      );
      this.myDefaultPages = this.myDefaultPages.map((x) => {
        return {
          id: x.id,
          title: x.title,
          roles: x.roles.filter((r) => self.hasPermission(r.role)),
        };
      });

      if (
        this.$store.state.app.isMobile &&
        this.hasPermission(["learningadmin", "learningteacher"])
      ) {
        this.$router.push("/lms/participant");
      }

      if (this.myDefaultPages.length == 1) {
        if (this.myDefaultPages[0].roles.length == 1) {
          this.$router.push(this.myDefaultPages[0].roles[0].rawLink);
        }
      }
    }
  },
  methods: {
    getToken() {
      return getToken();
    },
    hasPermission(arr) {
      if (this.$store.state.user.userId == "") return false;
      return hasOneOf(this.$store.state.user.userInfo.access, arr);
    },
    showAttestModal() {
      //attestMainType
      request({
        api: { method: "get", url: "type/getdata" },
        params: {
          key: "attestMainType",
          getParentType: false,
        },
        store: this.$store,
      }).then((res) => {
        //this.handleLoading({ isLoading: false });
        if (res != false) {
          this.attestModal.types = res.data.types;
          this.attestModal.show = true;
        }
      });
    },
  },
};
</script>
